import React, { useEffect, useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { injectReducer } from 'store'
import reducer from './store'
import { useDispatch, useSelector } from 'react-redux'
import { getData, setTableData } from './store/dataSlice'
import { HiOutlinePencil, HiOutlineTrash } from 'react-icons/hi'
import Tooltip from 'components/Ui/Tooltip'
import { Modal, ConfirmationModal, Table, Upload } from 'components/Ui'
import {
    getApiData,
    deleteApiRecord,
    uploadApiDataBoatRecords,
    uploadApiNetSuiteRecords,
    uploadApiNext3plRecords,
    uploadApiOrderRecords,
} from 'services/SalesOrdersService'
import { Success } from 'utils/alerts'
import useAuth from 'utils/hooks/useAuth'
import dayjs from 'dayjs'
import * as Yup from 'yup'
import { Field, Form, Formik } from 'formik'
import { Button, DatePicker, Select } from 'components/Form'
import { IntegrationOptions } from 'utils/options'
injectReducer('salesOrders', reducer)

const validationSchema = Yup.object().shape({
    file: Yup.string().required('file is required'),
    integration: Yup.string().required('integration is required'),
})

export default function SalesOrders() {
    const dispatch = useDispatch()
    const { checkPermission } = useAuth()
    const { data, tableData, loading } = useSelector(state => state.salesOrders.data)
    const { companyData, customersData, orderTypeFilterData } = useSelector(state => state.listData)
    const { company, customer } = useSelector(state => state.filterData)
    const [open, setOpen] = useState(false)

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        tableData.sort,
        tableData.query,
        tableData.pageIndex,
        tableData.pageSize,
        tableData.selectedTab,
        tableData.checkBox,
        tableData.orderType,
        tableData.startDate,
        company,
        customer,
    ])

    const fetchData = () => dispatch(getData({ ...tableData, company: company, customer: customer }))

    const filterData = () => {
        // const query = tableData?.query?.toLowerCase() || ''
        // const status = tableData?.selectedTab?.toLowerCase() || ''
        // const orderType = tableData?.orderType?.toLowerCase() || ''
        const sort = tableData?.sort || []

        // 1. Filter based on search query
        let filtered = data
            // ?.filter(item => {
            //     // Combine all values into a string to search across multiple columns
            //     const customerCode = customersData.find(c => c.id === item.customer)?.customer_code?.toLowerCase() || ''
            //     const companyCode = companyData.find(c => c.id === item.company)?.code?.toLowerCase() || ''
            //     const itemValues = Object.values(item).join(' ').toLowerCase() + ' ' + customerCode + ' ' + companyCode
            //     return itemValues.includes(query)
            // })
            // .filter(item => {
            //     if (status) {
            //         return item?.processed_to_wms?.toLowerCase() === status
            //     }
            //     return true
            // })
            // .filter(item => {
            //     if (orderType) {
            //         return item.order_type?.toLowerCase() === orderType
            //     }
            //     return true
            // })
            // .filter(item => {
            //     if (company) {
            //         return item?.company?.toString() === company
            //     }
            //     return true
            // })
            ?.filter(item => {
                // if (customer) {
                //     return item?.customer?.toString() === customer
                // }
                return true
            })

        // 2. Sort based on tableData.sort array
        if (sort?.length > 0) {
            sort?.forEach(({ column, dir }) => {
                filtered = filtered?.sort((a, b) => {
                    const aVal = a[column]
                    const bVal = b[column]

                    // Use localeCompare for strings, basic comparison for numbers
                    if (typeof aVal === 'string' && typeof bVal === 'string') {
                        return dir === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal)
                    } else {
                        return dir === 'asc' ? aVal - bVal : bVal - aVal
                    }
                })
            })
        }
        return filtered || []
    }

    const handleDelete = id => {
        deleteApiRecord(id)
            .then(() => {
                Success('Deleted Successfully!')
                fetchData()
            })
            .catch(error => console.log('Error: ', error))
    }

    const handleSubmit = values => {
        if (values.integration === 'data-boat') {
            uploadApiDataBoatRecords(values)
                .then(() => {
                    Success('File Uploaded Successfully!')
                    fetchData()
                })
                .catch(error => console.log('Error: ', error))
        } else if (values.integration === 'next3pl') {
            uploadApiNext3plRecords(values)
                .then(() => {
                    Success('File Uploaded Successfully!')
                    fetchData()
                })
                .catch(error => console.log('Error: ', error))
        } else if (values.integration === 'netsuite') {
            uploadApiNetSuiteRecords(values)
                .then(() => {
                    Success('File Uploaded Successfully!')
                    fetchData()
                })
                .catch(error => console.log('Error: ', error))
        } else {
            uploadApiOrderRecords(values)
                .then(() => {
                    Success('File Uploaded Successfully!')
                    fetchData()
                })
                .catch(error => console.log('Error: ', error))
        }
    }

    const columns = useMemo(
        () => [
            {
                header: 'Action',
                className: 'px-4',
                hide: false,
                renderCell: row => {
                    return (
                        <div className="flex items-center gap-3">
                            {checkPermission('sales-orders', 'edit') ? (
                                <Tooltip title={'Edit'}>
                                    <Link to={`/maestro/sales-orders/${row.id}/edit`} className="hover:text-primary">
                                        <HiOutlinePencil size={20} />
                                    </Link>
                                </Tooltip>
                            ) : null}
                            {checkPermission('sales-orders', 'delete') ? (
                                <Tooltip title={'Delete'}>
                                    <ConfirmationModal
                                        message={'Are you sure you want to delete this record!'}
                                        onConfirm={() => {
                                            handleDelete(row.id)
                                        }}
                                    >
                                        <span className="hover:text-danger">
                                            <HiOutlineTrash size={20} />
                                        </span>
                                    </ConfirmationModal>
                                </Tooltip>
                            ) : null}
                        </div>
                    )
                },
            },
            {
                field: 'warehouse_id',
                header: 'Whse',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
                // renderCell: row => siteLabel(row?.site),
            },
            {
                field: 'company',
                header: 'Company Code',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
                renderCell: row => companyData.find(item => item?.id === row?.company)?.code,
            },
            {
                field: 'customer',
                header: 'Customer Code',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
                renderCell: row => customersData.find(item => item?.id === row?.customer)?.customer_code,
            },
            {
                field: 'doc_no',
                header: 'Order No.',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'order_type',
                header: 'Order Type',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
                // renderCell: row => orderType(row?.order_type),
            },
            {
                field: 'so_reference_a',
                header: 'Reference A',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'so_reference_b',
                header: 'Reference B',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'priority',
                header: 'Priority',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'order_time',
                header: 'Date Created',
                className: 'min-w-[200px]',
                orderable: true,
                hide: false,
                renderCell: row => (row?.order_time ? dayjs(row?.order_time).format('MMM D, YYYY') : ''),
            },
            {
                field: 'expected_shipment_time1',
                header: 'Shipment Date',
                className: 'min-w-[200px]',
                orderable: true,
                hide: false,
                renderCell: row =>
                    row?.expected_shipment_time1 ? dayjs(row?.expected_shipment_time1).format('MMM D, YYYY') : '',
            },
            {
                field: 'consignee_name',
                header: 'Customer',
                className: 'min-w-[150px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'carrier_name',
                header: 'Carrier',
                className: 'min-w-[200px]',
                orderable: true,
                hide: false,
            },
            {
                field: 'processed_to_wms',
                header: 'Process flag',
                className: 'min-w-[200px]',
                orderable: true,
                hide: false,
            },
        ],
        // eslint-disable-next-line
        [
            tableData.sort,
            tableData.query,
            tableData.pageIndex,
            tableData.pageSize,
            tableData.selectedTab,
            tableData.checkBox,
            tableData.orderType,
            tableData.startDate,
            company,
            customer,
        ]
    )

    return (
        <>
            <div className="flex flex-col gap-1 mb-5 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">Sales Orders</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-4 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
                <DatePicker
                    id="satrt_date"
                    name="satrt_date"
                    placeholder="Start Date"
                    value={tableData.startDate}
                    onChange={e => dispatch(setTableData({ ...tableData, startDate: e.target.value }))}
                    className="w-full"
                    disabled={tableData.selectedTab === 'Y'}
                />
            </div>
            {console.log('orderTypeFilterData: ', orderTypeFilterData)}
            <Table
                localStorageKey={'sales-orders'}
                loading={loading}
                // filter={false}
                orderTypeFilter={true}
                orderTypeData={orderTypeFilterData}
                upload={checkPermission('sales-orders', 'create')}
                download={true}
                datas={filterData()}
                columns={columns}
                file_name={'Orders'}
                add_new={checkPermission('sales-orders', 'create') ? '/maestro/sales-orders/create' : ''}
                pagingData={tableData}
                onChange={e => dispatch(setTableData(e))}
                onUpload={() => setOpen(true)}
                csvDownloadApi={getApiData}
            />
            <Modal
                show={open}
                onClose={() => {
                    setOpen(false)
                }}
            >
                <div className="flex flex-col gap-1 m-3">
                    <h2 className="font-semibold text-black text-title-md">{'Import  Sales Order'}</h2>
                    <p>Automatically create new Sales Order by uploading your standard file</p>
                </div>
                <div className="flex flex-col items-center">
                    <div className="w-full bg-white border rounded-sm overflow-auto max-h-150 border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                        <div className="flex flex-col gap-3 p-6">
                            <Formik
                                initialValues={{ file: '', integration: '' }}
                                validationSchema={validationSchema}
                                onSubmit={values => {
                                    setOpen(false)
                                    handleSubmit(values)
                                }}
                            >
                                {({ values, touched, errors }) => (
                                    <Form>
                                        <div className="grid grid-cols-1 gap-x-4 gap-y-4">
                                            <Field name="integration">
                                                {({ field, form }) => (
                                                    <Select
                                                        options={IntegrationOptions}
                                                        label="Integration"
                                                        size="sm"
                                                        placeholder="Select"
                                                        name="integration"
                                                        // className="md:col-span-2"
                                                        error={errors.integration && touched.integration}
                                                        message={errors.integration}
                                                        value={values?.integration}
                                                        onChange={e => form.setFieldValue(field.name, e.target.value)}
                                                    />
                                                )}
                                            </Field>
                                            <Field name="file">
                                                {({ field, form }) => (
                                                    <Upload
                                                        onFilesSelected={files => form.setFieldValue(field.name, files[0])}
                                                        error={errors.file && touched.file}
                                                        message={errors.file}
                                                    />
                                                )}
                                            </Field>
                                            <div className="p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
                                                <h4 className="text-sm font-medium text-blue-900 dark:text-blue-100 mb-2">
                                                    Note: limited to 1 file per upload.
                                                </h4>
                                            </div>
                                        </div>
                                        <div className="flex items-center justify-end gap-4 mt-3">
                                            <Button
                                                className="h-10 w-18 text-[#F05540] border border-[#F05540] dark:text-[#F05540] dark:border-[#F05540]"
                                                onClick={() => setOpen(false)}
                                                type="button"
                                            >
                                                Discard
                                            </Button>
                                            <Button
                                                type="submit"
                                                className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-[#F05540] bg-[#F05540] dark:border-[#F05540] dark:bg-[#F05540]"
                                            >
                                                Save
                                            </Button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
